var map = {
	"./2.png": 281,
	"./3.png": 283,
	"./4.png": 285,
	"./5.png": 287,
	"./v2/2.png": 171,
	"./v2/3.png": 172,
	"./v2/4.png": 173,
	"./v2/5.png": 174,
	"./v2/border-jackpot.png": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;